import React, { useState } from "react";
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

import {
    Button,
    Box,
    Drawer,
    IconButton,
    useMediaQuery
} from "@mui/material";

import { gerarLinkWhatsApp } from "../../utils/GerarLinkWhatsapp";

const MenuItem = ({ children, active, navigate, loc }) => (
    <Box
        sx={{
            height: { xs: "50px", md: "120px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "fit-content",
            fontSize: { xs: "0.85rem", md: "1rem" },
            color: active ? "#0062A6" : "#727272ff",
            borderTop: { md: active ? "5px solid #0062A6" : "5px solid transparent" },
            fontWeight: 600,
            px: { xs: 1, md: 2 },
            cursor: "pointer",
            transition: "0.2s ease",
            "&:hover": {
                color: "#0062A6",
                borderTop: { md: "5px solid #0062A6" },
            }
        }}
        onClick={() => navigate(loc)}
    >
        {children}
    </Box>
);

const IconItem = ({ children, link }) => (
    <Box
        sx={{
            height: { xs: "40px", md: "120px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#727272ff",
            cursor: "pointer",
            transition: "0.2s ease",
            "&:hover": {
                color: "#0062A6",
                borderTop: { md: "5px solid #0062A6" },
            }
        }}
        onClick={() => link && window.open(link, "_blank")}
    >
        {children}
    </Box>
);

const Header = (props) => {

    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();

    const isMobile = useMediaQuery("(max-width: 1400px)");

    return (
        <>
            <Box
                component="header"
                sx={{
                    width: "100%",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: "3px solid #0062A6",
                    height: { xs: "70px", md: "120px" },
                    position: "fixed",
                }}
            >
                <Box
                    sx={{
                        width: { xs: "100%", md: "fit-content" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >

                    {/** Menu Mobile */}
                    {isMobile && (
                        <IconButton onClick={() => setMobileOpen(true)}>
                            <MenuIcon sx={{ fontSize: 32 }} />
                        </IconButton>
                    )}

                    {/** Logo */}
                    <Box
                        sx={{
                            height: { xs: "50px", md: "120px" },
                            display: isMobile ? "flex" : "none",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto"
                        }}
                    >
                        <img
                            src="assets/logoHeader.png"
                            alt="Logo Fiscaltec"
                            style={{ height: "50px" }}
                        />
                    </Box>
                    {/** Desktop Menu */}
                    {!isMobile && (
                        <>
                            <MenuItem active={props.active === "home"} navigate={navigate} loc="../" ><HomeIcon /></MenuItem>
                            <MenuItem active={props.active === "about"} navigate={navigate} loc="../SobreNos">SOBRE NÓS</MenuItem>
                            <MenuItem active={props.active === "solutions"} navigate={navigate} loc="../SolucoesEmEvidencia" >SOLUÇÕES EM EVIDÊNCIA</MenuItem>
                            {/** Logo */}
                            <Box
                                sx={{
                                    height: { xs: "60px", md: "120px" },
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mx: "auto"
                                }}
                            >
                                <img
                                    src="assets/logoHeader.png"
                                    alt="Logo Fiscaltec"
                                    style={{ height: "70px" }}
                                />
                            </Box>
                            <MenuItem active={props.active === "partners"} navigate={navigate} loc="../Socios">SÓCIOS</MenuItem>

                            <Box sx={{ display: "flex", gap: 1 }}>
                                <IconItem link="https://www.facebook.com/FiscalTecConsultoria"><FacebookIcon /></IconItem>
                                <IconItem link="https://www.instagram.com/FiscalTec"><InstagramIcon /></IconItem>
                                <IconItem link="https://www.linkedin.com/company/fiscaltec"><LinkedInIcon /></IconItem>
                            </Box>

                            <Button
                                variant="contained"
                                sx={{
                                    fontSize: "1rem",
                                    backgroundColor: "#0062A6",
                                    color: "white",
                                    minWidth: "160px",
                                    ml: 2,
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "0.3s ease",
                                    "&:hover": {
                                        backgroundColor: "#0170bd",
                                    },
                                }}
                                onClick={() =>
                                    window.open(
                                        gerarLinkWhatsApp("Olá, gostaria de solicitar uma visita técnica."),
                                        "_blank"
                                    )
                                }
                            >
                                solicitar visita
                            </Button>
                        </>
                    )}
                </Box>
            </Box>

            {/** Drawer Mobile */}
            <Drawer
                anchor="left"
                open={mobileOpen}
                onClose={() => setMobileOpen(false)}
            >
                <Box sx={{ width: 260, p: 2 }}>
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton onClick={() => setMobileOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <MenuItem active={props.active === "home"} navigate={navigate} loc="../">Home</MenuItem>
                    <MenuItem active={props.active === "about"} navigate={navigate} loc="../SobreNos">Sobre nós</MenuItem>
                    <MenuItem active={props.active === "solutions"} navigate={navigate} loc="../SolucoesEmEvidencia">Soluções</MenuItem>
                    <MenuItem active={props.active === "partners"} navigate={navigate} loc="../Socios">Sócios</MenuItem>

                    <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "center", width: "100%" }}>
                        <FacebookIcon onClick={() => window.open("https://www.facebook.com/FiscalTecConsultoria")} />
                        <InstagramIcon onClick={() => window.open("https://www.instagram.com/FiscalTec")} />
                        <LinkedInIcon onClick={() => window.open("https://www.linkedin.com/company/fiscaltec")} />
                    </Box>

                    <Button
                        fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            backgroundColor: "#0062A6",
                            color: "white",
                        }}
                        onClick={() =>
                            window.open(
                                gerarLinkWhatsApp("Olá, gostaria de solicitar uma visita técnica."),
                                "_blank"
                            )
                        }
                    >
                        solicitar visita
                    </Button>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;
